import { render, staticRenderFns } from "./AscStackedChart.vue?vue&type=template&id=5cfcbb0b&"
import script from "./AscStackedChart.vue?vue&type=script&lang=js&"
export * from "./AscStackedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports